// Version : 0.0.1
// Author : VISHAL BHARATHI
// LastEdit : VISHAL BHARATHI
// Last ADD : EXCEL PART REMOVED
// MODFIED DATA : 27-09-2025

import { takeLatest, put, all, call } from 'redux-saga/effects';

import ReceiptsPaymentsActionTypes from './ReceiptsPayments.types';

import { ReceiptsPaymentsListGet } from './ReceiptsPayments.services';

import {
	// GET RECEIPTS AND PAYMENTS LIST RESPONSE
	getReceiptsPaymentsDetailsSuccess,
	getReceiptsPaymentsDetailsFailure,
	getReceiptsPaymentsDetailsResponseChanged,
} from './ReceiptsPayments.action';

import { encryptData } from '../../../_common/enode-decode';

import AlertManager from '../../../../utils/alertManager';
/** *********************  START GET RECEIPTS PAYMENTS REPORT DETAILS  ******************** */
export function* getReceiptsPaymentsList({ payload }: any) {
	try {
		const key = 'GetReceiptsPaymentsKey';
		const {
			databaseName,
			infogCompanyID,
			fromDate,
			toDate,
			companyID,
			userID,
			userName,
			asOnDate,
			type,
			viewUser,
			userAccessBranchID,
			filterHOTrxn,
		} = payload;
		const jsonData = {
			DatabaseName: databaseName,
			Infog_CompanyID: infogCompanyID,
			FromDate: fromDate,
			ToDate: toDate,
			CompanyID: companyID,
			UserID: userID,
			UserName: userName,
			AsOnDate: asOnDate,
			Type: type,
			ViewUser: viewUser,
			UserAccessBranchID: userAccessBranchID,
			FilterHOTrxn: filterHOTrxn,
		};
		const encodeData = encryptData(jsonData, key);
		// @ts-ignore
		const responseData = yield call(ReceiptsPaymentsListGet, encodeData);
		// Check for 401 token validation error
		if (responseData.data.statusCode === '401') {
			// Show token validation alert
			AlertManager.showTokenValidationAlert();
			return;
		} else if (responseData.data.statusCode === '100') {
			yield put(getReceiptsPaymentsDetailsFailure(responseData.data));
		} else {
			yield put(getReceiptsPaymentsDetailsSuccess(responseData.data));
		}
	} catch (error) {
		yield put(getReceiptsPaymentsDetailsFailure(error));
	}
}

export function* resetGetReceiptsPaymentsListResponse() {
	yield put(getReceiptsPaymentsDetailsResponseChanged());
}

export function* onGetReceiptsPaymentsListDetails() {
	yield takeLatest(
		ReceiptsPaymentsActionTypes.GET_RECEIPTS_PAYMENTS_LIST_START,
		getReceiptsPaymentsList,
	);
}

export function* onGetReceiptsPaymentsListResponseReset() {
	yield takeLatest(
		ReceiptsPaymentsActionTypes.GET_RECEIPTS_PAYMENTS_LIST_RESPONSE_RESET,
		resetGetReceiptsPaymentsListResponse,
	);
}
/** *********************  END GET RECEIPTS PAYMENTS REPORT LIST ******************** */

export function* receiptsPaymentsSaga() {
	yield all([
		// GET RECEIPTS AND PAYMENTS LIST RESPONSE
		call(onGetReceiptsPaymentsListDetails),
		call(onGetReceiptsPaymentsListResponseReset),
	]);
}
